var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f9f9f9",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    stroke: "#f9f9f9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,20c-16.5,0-30,13.5-30,30s13.5,30,30,30s30-13.5,30-30S65.5,20,49,20z M72.8,47h-7.9 c-0.3-7.1-1.9-13.3-4.3-18C67.2,32.7,71.8,39.3,72.8,47z M46,27.3V47h-6.9C39.6,37.6,42.6,30.2,46,27.3z M46,53v19.7 c-3.4-2.9-6.4-10.3-6.9-19.7L46,53z M52,72.7V53h6.9C58.4,62.4,55.4,69.8,52,72.7z M52,47V27.3c3.4,2.9,6.4,10.3,6.9,19.7H52z M37.4,29c-2.4,4.7-3.9,10.9-4.3,18h-7.9C26.2,39.3,30.8,32.7,37.4,29z M25.2,53h7.9c0.3,7.1,1.9,13.3,4.3,18 C30.8,67.3,26.2,60.7,25.2,53z M60.6,71c2.4-4.7,3.9-10.9,4.3-18h7.9C71.8,60.7,67.2,67.3,60.6,71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/programs.6815f3c01ef922e657787fa0d49e0eb7.svg";
export { ForwardRef as ReactComponent };